import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const articles = document.querySelectorAll('.image-copy-swiper');
articles.forEach((articleElement, index) => {
    articleElement.classList.add(`image-copy-swiper-${index}`);

    // find the carousel-next and carousel-prev buttons within the same container
    let carouselNext = articleElement.querySelector('.carousel-next');
    let carouselPrev = articleElement.querySelector('.carousel-prev');
    let paginationEl = articleElement.querySelector('.swiper-pagination');
    
    if (carouselNext) carouselNext.classList.add(`carousel-next-${index}`);
    if (carouselPrev) carouselPrev.classList.add(`carousel-prev-${index}`);
    if (paginationEl) paginationEl.classList.add(`swiper-pagination-${index}`);

    const swiperConfig = {
        modules: [Navigation, Pagination],
        a11y: true,
        speed: 400,
        loop: true,
        centeredSlides: false,
        slidesPerView: 1,
        spaceBetween: 30,
        slideClass: 'swiper-slide',
    };

    // Add navigation if buttons exist
    if (carouselNext && carouselPrev) {
        swiperConfig.navigation = {
            addIcons: false,
            nextEl: `.carousel-next-${index}`,
            prevEl: `.carousel-prev-${index}`
        };
    }

    // Add pagination if element exists
    if (paginationEl) {
        swiperConfig.pagination = {
            el: `.swiper-pagination-${index}`,
            type: 'bullets',
            clickable: true
        };
    }

    const swiper = new Swiper(`.image-copy-swiper-${index}`, swiperConfig);
});
